// src/axiosConfig.js
import axios from 'axios';
import {
  getStoredToken,
  clearStoredAuth,
  isTestAppHost,
} from "./lib/authStorage";

const inferredBase =
  typeof window !== 'undefined'
    ? '/api'
    : 'http://localhost:5000';

const globalOverride =
  (typeof window !== 'undefined' && window.LOAD_EVO_API_BASE) || null;

const lsOverride =
  (typeof window !== 'undefined' && localStorage.getItem('API_BASE_OVERRIDE')) || null;

const envBase =
  typeof process !== 'undefined'
    ? (process.env.REACT_APP_API_BASE_URL ||
       process.env.REACT_APP_API_URL ||
       process.env.API_BASE_URL)
    : null;

const isProdHost =
  typeof window !== 'undefined' &&
  [
    '91.98.120.24',
    'www.loadevo.com',
    'loadevo.com',
    'app.loadevo.com',
  ].includes(window.location.hostname);

const API_BASE = (
  isProdHost || (typeof window !== "undefined" && isTestAppHost())
    ? '/api'
    : (globalOverride || lsOverride || envBase || inferredBase)
).replace(/\/$/, '');

if (typeof window !== 'undefined') {
  console.log('[api][debug]', {
    hostname: window.location.hostname,
    isProdHost,
    globalOverride,
    lsOverride,
    envBase,
    inferredBase,
    chosenApiBase: API_BASE,
  });
}

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.log('[api] base =', API_BASE);
}

const instance = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// ✅ Only attach Authorization if it looks like a real JWT
function looksLikeJwt(t) {
  if (typeof t !== 'string') return false;
  const raw = t.replace(/^Bearer\s+/i, '').trim();
  return /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(raw);
}

instance.interceptors.request.use((config) => {
  if (isTestAppHost()) {
    config.baseURL = "/api";

    const requestUrl = String(config.url || "");

    if (/^(https?:)?\/\//i.test(requestUrl)) {
      return Promise.reject(
        new Error("Absolute API URLs are not permitted in TEST")
      );
    }

    const requestPath =
      "/" + requestUrl.replace(/^\/+/, "").split("?")[0];

    // Manter proteção temporária enquanto existir
    // a exceção antiga no Nginx TEST.
    if (requestPath === "/loads/create") {
      return Promise.reject(
        new Error(
          "Load creation is temporarily disabled in TEST"
        )
      );
    }
  }

  const token = getStoredToken();

  if (looksLikeJwt(token)) {
    const raw = token.replace(/^Bearer\s+/i, "").trim();
    config.headers.Authorization = `Bearer ${raw}`;
  } else {
    delete config.headers.Authorization;
  }

  const fullUrl =
    `${(config.baseURL || "").replace(/\/$/, "")}/` +
    String(config.url || "").replace(/^\//, "");

  console.log(
    `[api] ${String(config.method || "GET").toUpperCase()} ${fullUrl}`
  );

  return config;
});

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const requestUrl = String(err?.config?.url || "");
    const currentPath =
      typeof window !== "undefined" ? window.location.pathname : "";

    const isAuthLoginRequest =
      requestUrl.includes("/auth/login");

    const isPublicAuthRoute =
      currentPath === "/" ||
      currentPath === "/forgot-password" ||
      currentPath === "/reset-password" ||
      currentPath === "/hq/login";

    if (status === 401) {
      // ❌ Nunca fazer redirect automático quando o 401 vem do próprio login
      if (isAuthLoginRequest) {
        return Promise.reject(err);
      }

      console.warn("[api] 401 Unauthorized → clearing stored auth");
      clearStoredAuth();

      // ✅ O teu login público está em "/"
      if (typeof window !== "undefined" && !isPublicAuthRoute) {
        window.location.assign("/");
      }
    }

    return Promise.reject(err);
  }
);

export default instance;